import { Paper } from './paper';

export default Paper;
export { PaddedPaper, PaddedPaperDashboard } from "./paper"